import { render, staticRenderFns } from "./DoughnutChartWithFiltersSection.vue?vue&type=template&id=00a8c616"
import script from "./DoughnutChartWithFiltersSection.vue?vue&type=script&lang=js"
export * from "./DoughnutChartWithFiltersSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports